import { Card, Modal } from 'react-bootstrap';
import { FC, useState } from 'react';
import { generalHthHelper } from '@monorepo/helpers';
import { HTHLocateFaceFromAddress } from '@/components/_commons/house-to-house/HTHLocateFaceFromAddress';
import { typeHTHFace } from '@monorepo/models';
import { useGetConfig, useGetIsDarkMode } from 'src/custom-hooks';
import { useNavigate } from 'react-router';

type propsType = {
    closeGeolocationModalHandler: () => void;
};

export const ManualLocationModal: FC<propsType> = ({ closeGeolocationModalHandler }) => {
    const [face, setFace] = useState<typeHTHFace | null>(null);
    const isDarkMode = useGetIsDarkMode();
    const config = useGetConfig();
    const navigate = useNavigate();

    return (
        <Modal
            fullscreen={'md-down'}
            onHide={closeGeolocationModalHandler}
            show
            size={'lg'}
        >
            <Modal.Header className={isDarkMode ? 'bg-dark text-white' : ''} closeButton>
                <Modal.Title>
                    Ubicar territorio, manzana y cara
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-dark text-white' : ''}>
                <HTHLocateFaceFromAddress
                    setValues={(f, sn) => {
                        setFace(f);
                    }}
                    values={{
                        face: null,
                        streetNumber: 0
                    }}
                />
                {face &&
                    <Card className='mt-5'>
                        <Card.Header className={isDarkMode ? 'bg-dark text-white' : ''}>
                            <h3>Respuesta</h3>
                        </Card.Header>
                        <Card.Body className={isDarkMode ? 'bg-dark text-white' : ''}>
                            <div>
                                <button className='btn btn-general-red btn-lg'
                                    onClick={() => navigate(`/casa-en-casa/${face.territoryNumber}?b=${face.block}&f=${face.face}`)}
                                >
                                    Territorio {face.territoryNumber} - Manzana {generalHthHelper.MaskTheBlock(face.block, config.isUsingLettersForBlocks)} - Cara "{generalHthHelper.MaskTheFace(face.face, config.isUsingLettersForBlocks)}": {face.street}
                                </button>
                            </div>
                        </Card.Body>
                    </Card>
                }
            </Modal.Body>
        </Modal>
    );
}
